import { decodeHtml } from '../../../Theme'
import { usePromo } from '../../state'

/**
 * CartPromoCmsBlock - Renders CMS block content for promo banner.
 *
 * Content comes from Magento CMS blocks (trusted admin-created content),
 * decoded via decodeHtml before rendering.
 */
export function CartPromoCmsBlock() {
  const { blockData } = usePromo()

  if (!blockData) return null

  // CMS block content is admin-created (trusted source), decoded for HTML entity rendering
  return (
    <div dangerouslySetInnerHTML={{ __html: decodeHtml(blockData.content) }} />
  )
}
